import { Page, TextSearchFilter } from '@/components';
import { Flex, Heading, useTableProps } from '@blockanalitica/ui';
import HistoricTabs from './HistoricTabs';
import PSM3DepositorsTable from './DepositorsTable';

export default function PSM3DepositorsPage() {
  const { pagination, sorting, filters } = useTableProps({
    pageSize: 10,
    initialSorting: '-balance',
    filtersDebounceTime: 250,
    initialFilters: {
      textSearch: ''
    }
  });

  return (
    <Page
      title={
        <Heading size="1">
          <Flex
            flexBasis="100%"
            gap={['xs', '2xs']}
            flexDirection={['column', 'row']}>
            PSM 3 Depositors
          </Flex>
        </Heading>
      }>
      <HistoricTabs />
      <Flex flexDirection="row" alignItems="center" justifyContent="flex-end">
        <TextSearchFilter filters={filters} placeholder="Search by wallet" />
      </Flex>
      <PSM3DepositorsTable
        pagination={pagination}
        sorting={sorting}
        search={filters.filtersApplied['textSearch']}
      />
    </Page>
  );
}
